import { render } from "./MOADocuments.vue?vue&type=template&id=470e89cb"
import script from "./MOADocuments.vue?vue&type=script&lang=js"
export * from "./MOADocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__